import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ScrollToTop from './components/ScrollToTop';
import ScrollManager from './components/ScrollManager';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import InvestorPage from './pages/InvestorPage';
import TechnologyPage from './pages/TechnologyPage';
import ApplicationsPage from './pages/ApplicationsPage';
import ContactPage from './pages/ContactPage';
import PartnersPage from './pages/PartnersPage';
import TermsOfService from './policies/TermsOfService';
import PrivacyPolicy from './policies/PrivacyPolicy';
import CookiePolicy from './policies/CookiePolicy';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <ScrollManager />
      <Routes>
        <Route path="/" element={
          <MainLayout>
            <HomePage />
          </MainLayout>
        } />
        <Route path="/investors" element={
          <MainLayout>
            <InvestorPage />
          </MainLayout>
        } />
        <Route path="/technology" element={
          <MainLayout>
            <TechnologyPage />
          </MainLayout>
        } />
        <Route path="/applications" element={
          <MainLayout>
            <ApplicationsPage />
          </MainLayout>
        } />
        <Route path="/contact" element={
          <MainLayout>
            <ContactPage />
          </MainLayout>
        } />
        <Route path="/partners" element={
          <MainLayout>
            <PartnersPage />
          </MainLayout>
        } />
        <Route path="/terms" element={
          <MainLayout>
            <TermsOfService />
          </MainLayout>
        } />
        <Route path="/privacy" element={
          <MainLayout>
            <PrivacyPolicy />
          </MainLayout>
        } />
        <Route path="/cookies" element={
          <MainLayout>
            <CookiePolicy />
          </MainLayout>
        } />
        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
};

export default App;